export default "__VITE_ASSET__c7dJAW$___"